export const getAbsoluteObjectCoords = (obj) => ({
    left: obj.group ? obj.group.left + (obj.group.getScaledWidth() / 2) + obj.left : obj.left,
    top: obj.group ? obj.group.top + (obj.group.getScaledHeight() / 2) + obj.top : obj.top
});
